/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface X509CertificateParams { 
    /**
     * PKCS#10 for create the X509 Certificate.
     */
    pkcs10: string;
}

